"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TopLabel = exports.TileLink = exports.Tile = exports.SpecsError = exports.Specs = exports.SpecValue = exports.SpecName = exports.Spec = exports.Name = exports.ModelTile = exports.JellyLabelError = exports.JellyError = exports.JellyDisclaimerError = exports.JellyDisclaimerContent = exports.JellyDisclaimer = exports.Jelly = exports.AsShown = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _index = _interopRequireDefault(require("../../PriceFormat/index.styled"));
var _breakpoints = _interopRequireDefault(require("../../breakpoints"));
const Tile = exports.Tile = _styledComponents.default.div`
  position: relative;
  height: 100%;
  box-sizing: border-box;
`;
const ModelTile = exports.ModelTile = _styledComponents.default.div`
  text-align: center;
  display: flex;
  flex-direction: column;
  height: 100%;
`;
const Jelly = exports.Jelly = _styledComponents.default.div`
  position: relative;
`;
const JellyError = exports.JellyError = _styledComponents.default.div`
  position: relative;
`;
const JellyLabelError = exports.JellyLabelError = _styledComponents.default.div`
  width: 100%;
  position: absolute;
  top: 40%;
  left: 0;
`;
const TileLink = exports.TileLink = _styledComponents.default.div`
  a {
    position: absolute;
    width: 100%;
    height: 100%;
    cursor: pointer;
    top: 0;
    left: 0;
  }
`;
const AsShown = exports.AsShown = _styledComponents.default.div``;
const Name = exports.Name = _styledComponents.default.div`
  height: 100%;
  display: flex;
  justify-content: center;
  position: relative;
`;
const Specs = exports.Specs = _styledComponents.default.div`
  text-align: center;
  position: relative;
  ${(0, _breakpoints.default)("tablet", "up")} {
    display: flex;
    justify-content: space-between;
    ${function (_ref) {
  let {
    $singleSpec
  } = _ref;
  return $singleSpec && `
    justify-content: center;
  `;
}}
  }
`;
const Spec = exports.Spec = _styledComponents.default.div`
  &:nth-child(1) {
    margin-bottom: 12px;
    ${(0, _breakpoints.default)("tablet", "up")} {
      margin-bottom: 0px;
    }
  }
  ${function (_ref2) {
  let {
    $singleSpec
  } = _ref2;
  return $singleSpec && `
  &:nth-child(1){
    margin-bottom: 0px;
  }
  `;
}}
`;
const SpecValue = exports.SpecValue = _styledComponents.default.div`
  ${_index.default.Price} {
    font: inherit;
  }
  ${_index.default.Symbol} {
    vertical-align: top;
  }
`;
const SpecName = exports.SpecName = _styledComponents.default.div``;
const SpecsError = exports.SpecsError = _styledComponents.default.div``;
const JellyDisclaimerContent = exports.JellyDisclaimerContent = _styledComponents.default.div``;
const JellyDisclaimer = exports.JellyDisclaimer = _styledComponents.default.div`
  margin-top: 3px;
  min-height: 12px;
`;
const JellyDisclaimerError = exports.JellyDisclaimerError = _styledComponents.default.div``;
const TopLabel = exports.TopLabel = _styledComponents.default.div``;